/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the KartraGenericDto interface.
 */
export function instanceOfKartraGenericDto(value) {
    if (!('fields' in value) || value['fields'] === undefined)
        return false;
    return true;
}
export function KartraGenericDtoFromJSON(json) {
    return KartraGenericDtoFromJSONTyped(json, false);
}
export function KartraGenericDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'fields': json['fields'],
    };
}
export function KartraGenericDtoToJSON(json) {
    return KartraGenericDtoToJSONTyped(json, false);
}
export function KartraGenericDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'fields': value['fields'],
    };
}
